import { createAction, props } from '@ngrx/store';

import { Ingredient } from '../../shared/model';

export const loadIngredientsRequest = createAction('[Ingredients] Load ingredients request');

export const loadIngredientsSuccess = createAction(
  '[Ingredients] Load ingredients success',
  props<{ ingredients: Ingredient[] }>(),
);
